import { render, staticRenderFns } from "./CommonBL.vue?vue&type=template&id=96f82ec0"
import script from "./CommonBL.vue?vue&type=script&lang=js"
export * from "./CommonBL.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/AzDevOps/myagent/_work/11/s/frontend/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('96f82ec0')) {
      api.createRecord('96f82ec0', component.options)
    } else {
      api.reload('96f82ec0', component.options)
    }
    module.hot.accept("./CommonBL.vue?vue&type=template&id=96f82ec0", function () {
      api.rerender('96f82ec0', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/trans/CommonBL.vue"
export default component.exports